import { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { Col, Label, Row } from 'reactstrap';

import { Tags as SharedTags } from 'pages/audience/shared/tags';
import { SaveForm } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities/strings';

const Tags: FC = () => {
  const { control } = useFormContext<SaveForm>();

  return (
    <Row className="mb-3">
      <Col
        className="align-items-center d-flex"
        sm={4}>
        <Label>{s('Site.Tag', { plural: true })}</Label>
      </Col>
      <Col>
        <Controller
          control={control}
          name="tags"
          render={({ field: { onChange, value } }) => (
            <SharedTags
              onSelected={(controlValue) => onChange(controlValue)}
              selected={value}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default Tags;
